import type { FollowerAbility } from '../../../schemas/follower';

/**
 * Abilità **Animista** (manuale V1, rr. 1355-1362).
 *
 * Un ciarlatano che chiacchiera coi morti e gioca a carte con gli spiriti.
 * Supporta il PG in interazioni con l'aldilà (ultimo respiro, evocazione
 * spiriti, antenati).
 */
export const animista: FollowerAbility = {
  id: 'animista',
  label: 'Animista',
  description:
    'Un ciarlatano che chiacchiera coi morti e gioca a carte con gli spiriti... ma è tutta scena? Forse no. Che abbiano davvero deciso di prenderlo sul serio?',
  ranks: [
    {
      rank: 1,
      trigger: "Quando qualcuno esala l'*ultimo respiro* in presenza di un Animista",
      description:
        'Questi intercede con la MORTE (che chissà perché ascolta quel farabutto), e quel qualcuno prende +1 al tiro di *ultimo respiro*.',
    },
    {
      rank: 2,
      trigger: "Quando un Animista invoca per te uno spirito della natura o un'anima defunta",
      description:
        "Questa appare, risponde a una sola domanda al meglio delle sue conoscenze, e poi svanisce. Non puoi scegliere *quale* spirito evocare: si manifesta quello più vicino o legato al luogo dell'evocazione. Una volta usata questa mossa, l'Animista non può usarla di nuovo fintanto che non vi *accampate*.",
    },
    {
      rank: 3,
      trigger: 'Quando un Animista invoca gli spiriti degli antenati affinché ti assistano',
      description:
        "Ottieni +1 al prossimo tiro. Dopo che ha usato questa mossa, l'Animista non può usarla di nuovo finché non vi *accampate*.",
    },
  ],
};
